import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 19L12 6",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5 12L12 5L19 12",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})]
});
export default SvgArrowUp;
